"use client";

import { CircularProgress } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";

interface LoadingProps {
  message?: string;
  fullscreen?: boolean;
  size?: number;
}

export const Loading: React.FC<LoadingProps> = ({
  message = "Loading...",
  fullscreen = false,
  size = 48,
}) => {
  const content = (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`flex flex-col items-center justify-center gap-3 ${
        fullscreen
          ? "h-screen w-full fixed inset-0 z-50 bg-white/80 backdrop-blur-sm"
          : "py-10"
      }`}
    >
      <CircularProgress size={size} />
      {message && (
        <p className="text-gray-600 text-sm font-medium tracking-wide">
          {message}
        </p>
      )}
    </motion.div>
  );

  return content;
};

export default Loading;
